import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileLines, faDownload } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';

function LabComponent (props) {
    return(
        <div className='single-credential single-lab shadow rounded'>
            <div className='credential-head'>
                <div className='credential-icon'>
                    <FontAwesomeIcon icon={props.icon} style={{color: props.iconColor, fontSize: "34px"}}/>
                </div>
                <div className='credential-heading'>
                    <h3>{props.title}</h3>
                    <span className='credential-issuer'>{props.platform} · {props.tags}</span>
                    <span className='credential-meta'>{props.meta}</span>
                </div>
            </div>
            <p className='credential-description'>{props.description}</p>
            <ul className='credential-highlights'>
                {props.highlights.map((highlight, index) => {
                    return <li key={index}>{highlight}</li>
                })}
            </ul>
            <div className='lab-actions'>
                <Link className='lab-btn' to={'/labs/' + props.slug}>
                    <FontAwesomeIcon icon={faFileLines} /> Read report
                </Link>
                <a className='lab-btn secondary' href={props.pdf} download>
                    <FontAwesomeIcon icon={faDownload} /> PDF
                </a>
            </div>
        </div>
    );
}

export default LabComponent;
